module.exports = __webpack_public_path__ + "img/ic-dash-client.578d4d9b.svg";